import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '@/hooks/redux';
import useNotification from '@/hooks/useNotification';
import { useTheme } from '@/hooks/useTheme';
import { seeUserNotifications } from '@/redux/alerts/alertSlice';
import { cn } from '@/utils/helper';

import AlertCard from './AlertCard';

const Alerts = () => {
  const { topBanner } = useAppSelector((state) => state.modal);
  const { mode } = useTheme();
  // const router = useRouter();
  // const { socket } = useSocket();
  const { notification } = useNotification();

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(seeUserNotifications());
  }, [dispatch]);

  // const acceptOrRejectInvite = async (body: Parameters<typeof handleInvites>[0] & { slug: string; userId: number; senderId: number }) => {
  //   socket?.emit(INVITE_ACCEPT, body, (res: TInviteCallback) => {
  //     if ('error' in res) {
  //       toast.error(res.error);
  //     }
  //     if ('data' in res) {
  //       router.push(`/channel/${body.slug}`);
  //     }
  //   });
  //   dispatch(handleInvitesAction({ inviteId: body.inviteId, status: body.status }));
  // };

  return (
    <div className={cn('mt-5', topBanner ? 'mt-20 md:mt-14' : '')}>
      <span className={`${mode === 'dark' ? 'bg-char-coal text-white' : 'text-coal-250 bg-light-blue-grey'} pt-6 text-[22px] font-semibold text-center z-10 absolute top-0 w-full left-0 lg:hidden`}>Alerts</span>
      <div className='flex flex-col gap-4'>
        {/* {
          // @ts-ignore
          loading ? (
            <Loader />
          ) : (
            notification?.notifications?.map((item, i) => {
              return <AlertCard key={i} data={item} />;
            })
          )
        } */}
        {!notification?.notifications?.length ? (
          <span className='text-sm'>There are no notifications to display</span>
        ) : (
          notification.notifications?.map((item, i) => {
            return <AlertCard key={i} data={item} />;
          })
        )}
      </div>
    </div>
  );
};

export { Alerts };
